// import React, { useState, useRef } from "react";
// import styles from './.FilterBoxComponents.module.css';

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


// const CompanyNameFilter = ({ companyIds, setCompanyIds, companyNameContains, setCompanyNameContains }) => {
//   const [companyInput, setCompanyInput] = useState('');
//   const [filteredSuggestions, setFilteredSuggestions] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
  
//   // Ref for the debounce timer, abort controller, and tracking the latest input value
//   const debounceTimeoutRef = useRef(null);
//   const abortControllerRef = useRef(null);
//   const latestQueryRef = useRef('');

//   // Fetch suggestions using the input provided
//   const fetchSuggestions = async (input) => {
//     // Cancel any previous fetch
//     if (abortControllerRef.current) {
//       abortControllerRef.current.abort();
//     }
//     abortControllerRef.current = new AbortController();
    
//     try {
//       const response = await fetch(`${API_BASE_URL}/get_company_suggestions`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ companyName: input }),
//         signal: abortControllerRef.current.signal,
//       });
      
//       if (!response.ok) {
//         console.error("Failed to fetch companies");
//         return;
//       }
      
//       const data = await response.json();
//       const suggestions = data.results || [];
      
//       // Remove duplicate IDs
//       const deduped = Array.from(
//         new Map(suggestions.map(item => [item.id, item])).values()
//       );
      
//       // Check using the latest query ref instead of state
//       if (input === latestQueryRef.current) {
//         setFilteredSuggestions(deduped);
//         setShowDropdown(deduped.length > 0);
//       }
      
//     } catch (error) {
//       if (error.name === 'AbortError') {
//         return; // Request was canceled, so we simply return.
//       }
//       console.error("Error fetching companies:", error);
//     }
//   };

//   // Debounce the fetch suggestions call
//   const handleCompanyInputChange = (event) => {
//     const input = event.target.value;
//     setCompanyInput(input);
//     latestQueryRef.current = input; // Update the latest query ref

//     // Clear any previous debounce timer
//     if (debounceTimeoutRef.current) {
//       clearTimeout(debounceTimeoutRef.current);
//     }

//     // Fetch suggestions only when the input isn't just whitespace
//     if (input.trim() !== "") {
//       debounceTimeoutRef.current = setTimeout(() => {
//         fetchSuggestions(input);
//       }, 500); // Wait 500ms after the last keystroke
//     } else {
//       setShowDropdown(false);
//       setFilteredSuggestions([]);
//     }
//   };

//   // Press Enter
//   const handleCompanyInputKeyDown = (event) => {
//     if (event.key === "Enter" && companyInput.trim() !== "") {
//       const matchingSuggestion = filteredSuggestions.find(
//         (company) =>
//           company.name_clean.toLowerCase() === companyInput.trim().toLowerCase()
//       );
//       if (matchingSuggestion) {
//         if (!companyIds.some(comp => comp.id === matchingSuggestion.id)) {
//           setCompanyIds([
//             ...companyIds,
//             { id: matchingSuggestion.id, name: matchingSuggestion.name_clean }
//           ]);
//         } else {
//           console.warn("Company already selected");
//         }
//       } else {
//         console.warn("Please select a valid company from the suggestions.");
//       }
//       setCompanyInput("");
//       setFilteredSuggestions([]);
//       setShowDropdown(false);
//       event.preventDefault();
//     }
//   };

//   // Click on a suggestion
//   const handleSelectSuggestion = (company) => {
//     if (!companyIds.some(comp => comp.id === company.id)) {
//       setCompanyIds([...companyIds, { id: company.id, name: company.name_clean }]);
//     } else {
//       console.warn("Company already selected");
//     }
//     setCompanyInput("");
//     setFilteredSuggestions([]);
//     setShowDropdown(false);
//   };

//   const removeCompany = (indexToRemove) => {
//     setCompanyIds(companyIds.filter((_, i) => i !== indexToRemove));
//   };

//   return (
//     <div className={styles.accordionContent}>
//       <label>Company Name</label>
//       <input
//         type="text"
//         placeholder="Enter company name or select..."
//         value={companyInput}
//         onChange={handleCompanyInputChange}
//         onKeyDown={handleCompanyInputKeyDown}
//         className={styles.filterInput}
//       />

//       {showDropdown && (
//         <ul className={styles.dropdown}>
//           {filteredSuggestions.map((company) => (
//             <li
//               key={company.id}
//               onClick={() => handleSelectSuggestion(company)}
//               className={styles.dropdownItem}
//             >
//               <img
//                 className={styles.companySuggestionImg}
//                 src={company.logo_url || '/DefaultCompanyLogo.jpeg'}
//                 alt=""
//               />
//               <span>{company.name_clean}</span>
//             </li>
//           ))}
//         </ul>
//       )}

//       <div className={styles.selectedSection}>
//         {companyIds.map((company, index) => (
//           <div key={company.id} className={styles.selectedChip}>
//             {company.name}
//             <button
//               onClick={() => removeCompany(index)}
//               className={styles.buttonX}
//             >
//               ×
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CompanyNameFilter;

import React, { useState, useRef } from "react";
import styles from './.FilterBoxComponents.module.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CompanyNameFilter = ({ 
  companyIds, 
  setCompanyIds, 
  companyNameContains, 
  setCompanyNameContains,
  companyWebsiteUrls,
  setCompanyWebsiteUrls
}) => {
  /* --- 1. Specific Company Selection (ID Based / API) --- */
  const [companyInput, setCompanyInput] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  
  const debounceTimeoutRef = useRef(null);
  const abortControllerRef = useRef(null);
  const latestQueryRef = useRef('');

  // Fetch suggestions using the input provided
  const fetchSuggestions = async (input) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    
    try {
      const response = await fetch(`${API_BASE_URL}/get_company_suggestions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ companyName: input }),
        signal: abortControllerRef.current.signal,
      });
      
      if (!response.ok) {
        console.error("Failed to fetch companies");
        return;
      }
      
      const data = await response.json();
      const suggestions = data.results || [];
      
      const deduped = Array.from(
        new Map(suggestions.map(item => [item.id, item])).values()
      );
      
      if (input === latestQueryRef.current) {
        setFilteredSuggestions(deduped);
        setShowDropdown(deduped.length > 0);
      }
      
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error("Error fetching companies:", error);
    }
  };

  const handleCompanyInputChange = (event) => {
    const input = event.target.value;
    setCompanyInput(input);
    latestQueryRef.current = input;

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    if (input.trim() !== "") {
      debounceTimeoutRef.current = setTimeout(() => {
        fetchSuggestions(input);
      }, 500);
    } else {
      setShowDropdown(false);
      setFilteredSuggestions([]);
    }
  };

  const handleCompanyInputKeyDown = (event) => {
    if (event.key === "Enter" && companyInput.trim() !== "") {
      const matchingSuggestion = filteredSuggestions.find(
        (company) =>
          company.name_clean.toLowerCase() === companyInput.trim().toLowerCase()
      );
      if (matchingSuggestion) {
        if (!companyIds.some(comp => comp.id === matchingSuggestion.id)) {
          setCompanyIds([
            ...companyIds,
            { id: matchingSuggestion.id, name: matchingSuggestion.name_clean }
          ]);
        } else {
          console.warn("Company already selected");
        }
      } else {
        console.warn("Please select a valid company from the suggestions.");
      }
      setCompanyInput("");
      setFilteredSuggestions([]);
      setShowDropdown(false);
      event.preventDefault();
    }
  };

  const handleSelectSuggestion = (company) => {
    if (!companyIds.some(comp => comp.id === company.id)) {
      setCompanyIds([...companyIds, { id: company.id, name: company.name_clean }]);
    } else {
      console.warn("Company already selected");
    }
    setCompanyInput("");
    setFilteredSuggestions([]);
    setShowDropdown(false);
  };

  const removeCompany = (indexToRemove) => {
    setCompanyIds(companyIds.filter((_, i) => i !== indexToRemove));
  };


  /* --- 2. Company Name Includes (Free Text Input) --- */
  const [includesInput, setIncludesInput] = useState('');

  const handleIncludesInputChange = (event) => {
    setIncludesInput(event.target.value);
  };

  const handleIncludesInputKeyDown = (event) => {
    if (event.key === "Enter" && includesInput.trim() !== "") {
      const newString = includesInput.trim();
      
      // Check for duplicates (case-insensitive)
      if (!companyNameContains.some(str => str.toLowerCase() === newString.toLowerCase())) {
        setCompanyNameContains([...companyNameContains, newString]);
      } else {
        // Update casing if it already exists
        setCompanyNameContains(companyNameContains.map(str =>
          str.toLowerCase() === newString.toLowerCase() ? newString : str
        ));
      }
      setIncludesInput("");
      event.preventDefault();
    }
  };

  const removeIncludesString = (indexToRemove) => {
    setCompanyNameContains(companyNameContains.filter((_, index) => index !== indexToRemove));
  };

/* --- 3. Company Website URLs (Free Text Input) --- */
  const [websiteUrlInput, setWebsiteUrlInput] = useState('');

  const handleWebsiteUrlInputChange = (event) => {
    setWebsiteUrlInput(event.target.value);
  };

  const handleWebsiteUrlInputKeyDown = (event) => {
    if (event.key === "Enter" && websiteUrlInput.trim() !== "") {
      
      // 1. Grab the input
      let cleanedUrl = websiteUrlInput.trim();
      
      // 2. Apply cleaning logic
      cleanedUrl = cleanedUrl.replace('https://', '');
      cleanedUrl = cleanedUrl.replace('http://', '');
      cleanedUrl = cleanedUrl.replace('www.', '');
      
      if (cleanedUrl.endsWith('/')) {
        cleanedUrl = cleanedUrl.slice(0, -1);
      }

      // 3. Prevent adding empty strings if they just typed "https://"
      if (cleanedUrl === "") {
        setWebsiteUrlInput("");
        event.preventDefault();
        return;
      }
      
      // 4. Check for duplicates (case-insensitive)
      if (!companyWebsiteUrls.some(url => url.toLowerCase() === cleanedUrl.toLowerCase())) {
        setCompanyWebsiteUrls([...companyWebsiteUrls, cleanedUrl]);
      } else {
        // Update casing if it already exists
        setCompanyWebsiteUrls(companyWebsiteUrls.map(url =>
          url.toLowerCase() === cleanedUrl.toLowerCase() ? cleanedUrl : url
        ));
      }
      setWebsiteUrlInput("");
      event.preventDefault();
    }
  };

  const removeWebsiteUrl = (indexToRemove) => {
    setCompanyWebsiteUrls(companyWebsiteUrls.filter((_, index) => index !== indexToRemove));
  };

  return (
    <div className={styles.accordionContent}>
      {/* 1. Specific Company Section */}
      <label>Specific Company</label>
      <input
        type="text"
        placeholder="Search for specific company..."
        value={companyInput}
        onChange={handleCompanyInputChange}
        onKeyDown={handleCompanyInputKeyDown}
        className={styles.filterInput}
      />

      {showDropdown && (
        <ul className={styles.dropdown}>
          {filteredSuggestions.map((company) => (
            <li
              key={company.id}
              onClick={() => handleSelectSuggestion(company)}
              className={styles.dropdownItem}
            >
              <img
                className={styles.companySuggestionImg}
                src={company.logo_url || '/DefaultCompanyLogo.jpeg'}
                alt=""
              />
              <span>{company.name_clean}</span>
            </li>
          ))}
        </ul>
      )}

      <div className={styles.selectedSection}>
        {companyIds.map((company, index) => (
          <div key={company.id} className={styles.selectedChip}>
            {company.name}
            <button
              onClick={() => removeCompany(index)}
              className={styles.buttonX}
            >
              ×
            </button>
          </div>
        ))}
      </div>

      {/* 2. Company Name Includes Section */}
      <label>Company Name Includes</label>
      <input
        type="text"
        placeholder="Enter text and press ENTER..."
        value={includesInput}
        onChange={handleIncludesInputChange}
        onKeyDown={handleIncludesInputKeyDown}
        className={styles.filterInput}
      />
      
      <div className={styles.selectedSection}>
        {companyNameContains.map((str, index) => (
          <div key={index} className={styles.selectedChip}>
            {str}
            <button 
              onClick={() => removeIncludesString(index)} 
              className={styles.buttonX}
            >
              ×
            </button>
          </div>
        ))}
      </div>
      {/* 3. Company Website URLs Section */}
      <label>Company Website URLs</label>
      <input
        type="text"
        placeholder="Enter URL (e.g., example.com) and press ENTER..."
        value={websiteUrlInput}
        onChange={handleWebsiteUrlInputChange}
        onKeyDown={handleWebsiteUrlInputKeyDown}
        className={styles.filterInput}
      />
      
      <div className={styles.selectedSection}>
        {companyWebsiteUrls.map((url, index) => (
          <div key={index} className={styles.selectedChip}>
            {url}
            <button 
              onClick={() => removeWebsiteUrl(index)} 
              className={styles.buttonX}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyNameFilter;
